import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SeriesChip from './SeriesChip'

// Horizontal strip of `SeriesChip`s ending with whatever the caller
// supplies via `trailing` (typically the `+ Compare` button). Lives
// just above the chart body so the user sees their active comparison
// set at a glance and can prune individual series.
//
// Each item optionally carries `{ mode, effectiveMode }`; the strip
// forwards them along with `onModeChange(id, nextMode)` so the chip's
// kebab can flip per-series cumulative mode.

const useStyles = makeStyles(() => ({
  strip: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 6
  }
}))

export default function SeriesChipStrip ({ items, onRemove, onModeChange, trailing }) {
  const classes = useStyles()
  if (!items || items.length === 0) return null
  return (
    <div className={classes.strip} role='list' aria-label='Active trend series'>
      {items.map((item, idx) => (
        <SeriesChip
          key={item.id}
          color={item.color}
          label={item.label}
          isPrimary={idx === 0}
          hint={item.hint}
          mode={item.mode || undefined}
          effectiveMode={item.effectiveMode || undefined}
          onModeChange={onModeChange ? (next) => onModeChange(item.id, next) : undefined}
          onRemove={item.removable === false || idx === 0 ? null : () => onRemove(item.id)}
        />
      ))}
      {trailing}
    </div>
  )
}

SeriesChipStrip.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    hint: PropTypes.string,
    removable: PropTypes.bool,
    mode: PropTypes.oneOf(['cumulative', 'perPeriod']),
    effectiveMode: PropTypes.oneOf(['cumulative', 'perPeriod'])
  })),
  onRemove: PropTypes.func.isRequired,
  onModeChange: PropTypes.func,
  trailing: PropTypes.node
}
